
import chatr from './img/chatr.png'
import lucky from './img/lucky.png'
import { NavLink } from 'react-router-dom';
import topup from './img/topup.png'
import activation from './img/activation.png'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'

function Mainpage() {
  const navigate = useNavigate()
  useEffect(()=>{
    navigate("/carrier")
  },[])
  return (
  <div style={{display:'flex', flexWrap:'wrap',justifyContent:'space-evenly', alignItems:'center', width:'100%', height:'90vh'}}>
    
  </div>
 );
}

export default Mainpage;
